import React, { useEffect } from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const { login, isAuthenticated, isLoading, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate('/klinks/list', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show nothing while checking authentication status
  if (isLoading) {
    return null;
  }

  // Don't render login form if already authenticated
  if (isAuthenticated) {
    return null;
  }

  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) {
    return <div>Error: Google Client ID not configured</div>;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
        color: '#333'
      }}>
        <h1 style={{ color: '#0056b3' }}>k-links login</h1>
        <p>Please sign in with your Google account to manage your k-links.</p>
        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        <div style={{ marginTop: '20px' }}>
          <GoogleLogin
            onSuccess={login}
            onError={() => console.error("Login Failed")}
          />
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginPage;
